import { THEME_ENUM } from '@/constants';
import { isMobile } from 'react-device-detect';

export type TvWidget = TradingView.IChartingLibraryWidget & {
  _id?: string;
  _ready?: boolean;
};
export const colors = {
  dark: {
    borderlightline1: '#1E3436',
    textMainBody: '#90C0BA',
    background: isMobile ? '#030B0E' : '#0B1A1D',
  },
  light: {
    borderlightline1: '#DDF5F3',
    textMainBody: '#446E6E',
    background: '#F7FBFA',
  },
};
export const TvTheme: { [id in TradingView.ThemeName]: Partial<TradingView.ChartPropertiesOverrides> } = {
  dark: {
    'paneProperties.separatorColor': colors['dark'].borderlightline1,
    'scalesProperties.lineColor': colors['dark'].borderlightline1,
    'paneProperties.background': colors['dark'].background,
    'paneProperties.backgroundType': 'solid',
    'scalesProperties.textColor': colors['dark'].textMainBody,
  },
  light: {
    'paneProperties.separatorColor': colors['light'].borderlightline1,
    'scalesProperties.lineColor': colors['light'].borderlightline1,
    'paneProperties.background': colors['light'].background,
    'paneProperties.backgroundType': 'solid',
    'scalesProperties.textColor': colors['light'].textMainBody,
  },
};

export const THEME_ENUM_TV_VIEW_MAP: { [id in THEME_ENUM]: TradingView.ThemeName } = {
  [THEME_ENUM.DARK]: 'dark',
  [THEME_ENUM.LIGHT]: 'light',
};

export const defaultResolutionString = '60' as TradingView.ResolutionString;

export const TVResolution = {
  '1': { server: '1min', name: '1m' },
  '5': { server: '5min', name: '5m' },
  '15': { server: '15min', name: '15m' },
  '30': { server: '30min', name: '30m' },
  '60': { server: '60min', name: '1h' },
  '240': { server: '4hour', name: '4h' },
  '1D': { server: '1day', name: '1D' },
  '1W': { server: '1week', name: '1W' },
  '1M': { server: '1mon', name: '1M' },
};
